import { ElementType, Suspense, useEffect, useState, lazy } from "react";
import { APP_ROUTES } from "./APP_ROUTES";
import JsonData from "../data/data1.json";
import { dataEmpty } from "../mocks/pagesData";
import { Data } from "../utils/pagesData";
import { ProgressBar } from "../components";

export interface AppRoute {
  element: JSX.Element;
  path: APP_ROUTES;
}

const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <Suspense fallback={<ProgressBar />}>
      <Component {...props} />
    </Suspense>
  );
};

export const useGetRoutesArray = () => {
  const [landingPageData, setLandingPageData] = useState<Data>(dataEmpty);

  useEffect(() => {
    setLandingPageData(JsonData);
  }, []);

  const routes: AppRoute[] = [
    {
      path: APP_ROUTES.MAIN,
      element: <HomePage data={landingPageData.Home} />,
    },

    // golodnii krolik
    {
      path: APP_ROUTES.GOLODNII_KROLIK,
      element: <GolodniiKrolikMenuPage data={landingPageData.GolodniiKrolik} />,
    },
    {
      path: APP_ROUTES.GOLODNII_KROLIK_MENU,
      element: <GolodniiKrolikMenuPage data={landingPageData.GolodniiKrolik} />,
    },
    {
      path: APP_ROUTES.GOLODNII_KROLIK_ABOUT_AS,
      element: (
        <GolodniiKrolikAboutAsPage data={landingPageData.GolodniiKrolik} />
      ),
    },
    {
      path: APP_ROUTES.GOLODNII_KROLIK_CONTACTS,
      element: (
        <GolodniiKrolikContactsPage data={landingPageData.GolodniiKrolik} />
      ),
    },

    // m_lounge
    {
      path: APP_ROUTES.M_LOUNGE,
      element: <MLoungeMenuPage data={landingPageData.MLounge} />,
    },
    {
      path: APP_ROUTES.M_LOUNGE_MENU,
      element: <MLoungeMenuPage data={landingPageData.MLounge} />,
    },
    {
      path: APP_ROUTES.M_LOUNGE_ABOUT_AS,
      element: <MLoungeAboutAsPage data={landingPageData.MLounge} />,
    },
    {
      path: APP_ROUTES.M_LOUNGE_BIZNES_LANCH,
      element: <MLoungeBiznesLanchPage data={landingPageData.MLounge} />,
    },
    {
      path: APP_ROUTES.M_LOUNGE_CONTACTS,
      element: <MLoungeContactsPage data={landingPageData.MLounge} />,
    },
    {
      path: APP_ROUTES.M_LOUNGE_REVIEWS,
      element: <MLoungeReviewsPage />,
    },

    // {
    //   path: APP_ROUTES.LET_IT_BE,
    //   element: <LetItBePage />,
    // },
    {
      path: APP_ROUTES.NOT_FOUND,
      element: <PageNotFound />,
    },
  ];

  return routes;
};

// m_lounge

const MLoungeMenuPage = Loadable(
  lazy(() => import("../pages/MLounge/MLoungeMenuPage/MLoungeMenuPage"))
);
const MLoungeAboutAsPage = Loadable(
  lazy(() => import("../pages/MLounge/MLoungeAboutAsPage/MLoungeAboutAsPage"))
);
const MLoungeBiznesLanchPage = Loadable(
  lazy(
    () =>
      import("../pages/MLounge/MLoungeBiznesLanchPage/MLoungeBiznesLanchPage")
  )
);
const MLoungeContactsPage = Loadable(
  lazy(() => import("../pages/MLounge/MLoungeContactsPage/MLoungeContactsPage"))
);
const MLoungeReviewsPage = Loadable(
  lazy(() => import("../pages/MLounge/MLoungeReviewsPage/MLoungeReviewsPage"))
);

// golodnii_krolik

const GolodniiKrolikMenuPage = Loadable(
  lazy(
    () =>
      import(
        "../pages/GolodniiKrolik/GolodniiKrolikMenuPage/GolodniiKrolikMenuPage"
      )
  )
);
const GolodniiKrolikAboutAsPage = Loadable(
  lazy(
    () =>
      import(
        "../pages/GolodniiKrolik/GolodniiKrolikAboutAsPage/GolodniiKrolikAboutAsPage"
      )
  )
);
const GolodniiKrolikContactsPage = Loadable(
  lazy(
    () =>
      import(
        "../pages/GolodniiKrolik/GolodniiKrolikContactsPage/GolodniiKrolikContactsPage"
      )
  )
);

// home

const HomePage = Loadable(lazy(() => import("../pages/HomePage/HomePage")));

// 404

const PageNotFound = Loadable(lazy(() => import("../pages/404/404")));
